(function () {
  // Frakttrappa – må matche fraktprofilen i Shopify (Innstillinger > Frakt og levering)
  // og trinnlista i snippets/cart-drawer.liquid + sections/main-cart.liquid.
  // Beløp i øre. `fra` er kurvsummen der satsen begynner å gjelde.
  var SHIP_TIERS = [
    { fra: 0,      pris: 23900 },
    { fra: 20000,  pris: 14900 },
    { fra: 50000,  pris: 7900  },
    { fra: 149900, pris: 0     }
  ];
  var root = document.getElementById('dreamy-cart-drawer');
  if (!root) return;
  var body = root.querySelector('.dcd__body');
  var shipMsg = root.querySelector('.dcd__ship-msg');
  var shipFill = root.querySelector('.dcd__ship-fill');
  var totalEl = root.querySelector('.dcd__total');
  var countEl = root.querySelector('.dcd__count');
  var upsell = root.querySelector('.dcd__upsell');
  var upsellList = root.querySelector('.dcd__upsell-list');
  var upsellSlider = root.querySelector('.dcd__upsell-slider');
  var lastProductId = null;

  function money(cents) {
    return (cents / 100).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  }
  // Kortform: runde beløp uten desimaler, så «239 kr» ikke blir «239,00 kr».
  function kr(cents) {
    var v = cents / 100;
    return v.toLocaleString('nb-NO', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr';
  }
  function sized(url, px) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_' + px + 'x$1$2') : ''; }

  function setBadge(count) {
    var link = document.querySelector('.cart-link .cart-icon') || document.querySelector('.cart-link');
    var badge = document.querySelector('.header__cart-count');
    if (count > 0) {
      if (!badge && link) { badge = document.createElement('span'); badge.className = 'cart-badge header__cart-count'; link.appendChild(badge); }
      if (badge) badge.textContent = count;
    } else if (badge) { badge.remove(); }
  }

  // Hvilken sats gjelder nå, og hva er neste trinn kunden kan strekke seg etter?
  function tierNow(total) {
    var t = SHIP_TIERS[0];
    for (var i = 0; i < SHIP_TIERS.length; i++) { if (total >= SHIP_TIERS[i].fra) t = SHIP_TIERS[i]; }
    return t;
  }
  function tierNext(total) {
    for (var i = 0; i < SHIP_TIERS.length; i++) { if (SHIP_TIERS[i].fra > total) return SHIP_TIERS[i]; }
    return null;
  }

  // Trinnlista står i snippeten; her merkes bare raden kunden ligger på.
  var tierRows = root.querySelectorAll('.dcd__tiers li');
  function markTiers(now) {
    for (var i = 0; i < tierRows.length; i++) {
      tierRows[i].classList.toggle('is-now', parseInt(tierRows[i].getAttribute('data-tier'), 10) === now.pris);
    }
  }

  function renderShip(total) {
    var now = tierNow(total);
    var next = tierNext(total);
    markTiers(now);
    if (!next) {
      shipMsg.innerHTML = 'Sånn! Du har <strong>gratis frakt</strong> på bestillingen din.';
      shipFill.style.width = '100%';
      return;
    }
    // Rund opp til hele kroner. Står kurven på 199,99 skal det stå «1 kr», ikke
    // «0,01 kr» – og oppover, så beløpet aldri er for lavt til å nå trinnet.
    var mangler = Math.ceil((next.fra - total) / 100) * 100;
    // Vis både hva frakten er nå og hva den blir – da ser kunden gevinsten,
    // ikke bare et beløp å fylle opp til.
    shipMsg.innerHTML =
      'Frakt nå <strong>' + kr(now.pris) + '</strong>. Kjøp for <strong>' +
      kr(mangler) + '</strong> til, så blir den <strong>' +
      (next.pris === 0 ? 'gratis' : kr(next.pris)) + '</strong>.';
    // Linja fylles mot NESTE trinn, ikke mot 1499 – ellers ser en liten kurv
    // håpløst langt unna når den egentlig er noen tiere fra halv frakt.
    shipFill.style.width = Math.min(100, (total / next.fra) * 100) + '%';
  }

  // Førpris (compare_at) finnes IKKE i /cart.js – hentes per produkt og caches,
  // slik at tilbudet er synlig i kurv-popupen på samme måte som på produktkortet.
  var caCache = {};
  function fetchCompareAt(items) {
    var handles = [];
    (items || []).forEach(function (it) {
      var h = it.handle || (it.url ? String(it.url).split('/products/')[1] : '');
      if (h) { h = h.split('?')[0]; if (handles.indexOf(h) === -1) handles.push(h); }
    });
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { (p.variants || []).forEach(function (v) { caCache[v.id] = v.compare_at_price || 0; }); })
        .catch(function () {});
    }));
  }

  // one line item (accepts either an add.js item or a cart.js item)
  function prisHtml(it, line) {
    var vid = it.variant_id || it.id;
    var ca  = caCache[vid] || 0;
    var qty = it.quantity || 1;
    var enhet = (it.final_price != null) ? it.final_price : (it.price || 0);
    if (ca > enhet) {
      var pct = Math.floor((ca - enhet) * 100 / ca);
      return '<b class="dcd__price-now">' + money(line) + '</b>' +
             '<s class="dcd__price-was">' + money(ca * qty) + '</s>' +
             '<span class="dcd__price-save">Du sparer ' + pct + '%</span>';
    }
    return '<b>' + money(line) + '</b>';
  }

  function itemHtml(it) {
    var vt = it.variant_title;
    var variant = (vt && vt !== 'Default Title') ? '<div class="dcd__item-variant">' + vt + '</div>' : '';
    var imgUrl = it.image || (it.featured_image && it.featured_image.url) || '';
    var line = (it.final_line_price != null) ? it.final_line_price : ((it.price || 0) * (it.quantity || 1));
    return '<div class="dcd__item">' +
      (imgUrl ? '<img class="dcd__item-img" src="' + sized(imgUrl, 140) + '" alt="" loading="lazy">' : '<span class="dcd__item-img"></span>') +
      '<div class="dcd__item-body">' +
        '<div class="dcd__item-stock">På lager</div>' +
        '<div class="dcd__item-title">' + it.product_title + '</div>' + variant +
      '</div>' +
      '<div class="dcd__item-price">' + prisHtml(it, line) + '</div>' +
    '</div>';
  }

  function renderItems(items) {
    function paint() {
      body.innerHTML = (items && items.length) ? items.map(itemHtml).join('') : '<div class="dcd__item">Handlekurven er tom.</div>';
    }
    paint();                                   // vis umiddelbart
    if (items && items.length) {
      fetchCompareAt(items).then(paint);       // tegn på nytt med førpris når den er hentet
    }
  }

  function refreshTotals() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setBadge(cart.item_count);
        countEl.textContent = cart.item_count;
        totalEl.textContent = money(cart.total_price);
        renderShip(cart.total_price);
        return cart;
      });
  }

  function updateArrows() {
    if (!upsellSlider) return;
    upsellSlider.classList.toggle('can-prev', upsellList.scrollLeft > 4);
    upsellSlider.classList.toggle('can-next', upsellList.scrollLeft + upsellList.clientWidth < upsellList.scrollWidth - 4);
  }

  function loadUpsell() {
    upsell.hidden = true;
    if (!lastProductId) return;
    fetch('/recommendations/products.json?product_id=' + lastProductId + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data && data.products) || [];
        var html = prods.map(function (p) {
          var vid = p.variants && p.variants[0] && p.variants[0].id;
          if (!vid || !p.available) return '';
          return '<div class="dcd__u-card">' +
            (p.featured_image ? '<img src="' + sized(p.featured_image, 200) + '" alt="" loading="lazy">' : '<span class="u-ph"></span>') +
            '<a class="u-title" href="' + p.url + '">' + p.title + '</a>' +
            '<span class="u-price">' + money(p.price) + '</span>' +
            '<button type="button" class="u-add" data-vid="' + vid + '">Legg til</button>' +
          '</div>';
        }).join('');
        if (html.replace(/\s/g, '')) {
          upsellList.innerHTML = html;
          upsell.hidden = false;
          // show the "next" arrow only when the row overflows
          upsellList.removeEventListener('scroll', updateArrows);
          upsellList.addEventListener('scroll', updateArrows);
          setTimeout(updateArrows, 450);
        }
      }).catch(function () {});
  }

  function renderSkeleton() {
    body.innerHTML =
      '<div class="dcd__item">' +
        '<span class="dcd__item-img dcd__skel"></span>' +
        '<div class="dcd__item-body">' +
          '<span class="dcd__skel dcd__skel--line is-short"></span>' +
          '<span class="dcd__skel dcd__skel--line"></span>' +
        '</div>' +
      '</div>';
  }

  // Bare vis panelet – ingen nettverkskall. Skilles ut så skuffen kan
  // åpnes før serveren har svart.
  function openShell() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var sc = root.querySelector('.dcd__scroll'); if (sc) sc.scrollTop = 0;
  }

  function open(addedItems) {
    openShell();
    if (addedItems && addedItems.length) {
      renderItems(addedItems);
      refreshTotals();
    } else {
      refreshTotals().then(function (cart) { renderItems(cart.items); });
    }
    loadUpsell();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // add variant(s), then open the drawer showing what was just added
  function addAndOpen(items) {
    lastProductId = null;
    // Åpne med én gang – kunden skal ikke vente på nettverket før noe skjer.
    openShell();
    renderSkeleton();
    upsell.hidden = true;
    totalEl.textContent = '–';   // unngå å vise forrige sum mens vi venter
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        var added = (res.ok && res.d && res.d.items) ? res.d.items : null;
        if (added && added.length) {
          lastProductId = added[added.length - 1].product_id;
          renderItems(added);
          refreshTotals();
        } else {
          refreshTotals().then(function (cart) { renderItems(cart.items); });
        }
        loadUpsell();
        return res;
      })
      .catch(function (err) {
        // Nettverksfeil: ikke la skjelettet bli stående
        refreshTotals().then(function (cart) { renderItems(cart.items); })
          .catch(function () { body.innerHTML = '<div class="dcd__item">Kunne ikke oppdatere kurven. Prøv igjen.</div>'; });
        throw err;
      });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-dcd-close]')) { close(); return; }
    var nav = e.target.closest('.dcd__u-nav');
    if (nav) { upsellList.scrollBy({ left: nav.classList.contains('dcd__u-prev') ? -320 : 320, behavior: 'smooth' }); return; }
    var add = e.target.closest('.u-add');
    if (add) {
      add.disabled = true; add.textContent = '✓';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(add.dataset.vid, 10), quantity: 1 }] })
      }).then(function () { return refreshTotals(); }).then(function () { add.disabled = false; add.textContent = 'Lagt til'; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  window.DreamyCart = { open: open, close: close, addAndOpen: addAndOpen, refresh: refreshTotals };
})();